import React from 'react';
import { XIcon, ZapIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
const NOT = ['No es un libro más para su estantería.', 'No es un curso de 20 horas que nunca terminará.', 'No es una recopilación desordenada de artículos científicos.'];
export function WhatItIs() {
  return <section className="w-full bg-navy-950 py-12 sm:py-16" aria-labelledby="what-title" data-id="element-240" data-mp="1nhyymnossonn">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-241" data-mp="2b834l1pgl0ht">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-400" data-id="element-242" data-mp="2b68frcb2go8g">
          Sistema Maestro de TRT™
        </p>
        <h2 id="what-title" className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-243" data-mp="228g20ckzton6">
          Todo lo que necesita para decidir con seguridad, en un solo lugar
        </h2>

        <ul className="mt-7 space-y-2.5" data-id="element-244" data-mp="qukmh2q6fdvf">
          {NOT.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 p-3.5" data-id="element-245" data-mp="vt5o96l2u5lz">
              <XIcon className="mt-1 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-246" data-mp="3oeyd0sqpg0b0" />
              <span className="text-[14px] font-medium leading-snug text-cream-100/85 sm:text-[15px]" data-id="element-247" data-mp="76l5nzmbpojo">
                {item}
              </span>
            </li>)}
        </ul>

        <div className="mt-4 flex items-start gap-3 rounded-2xl border-2 border-gold-500 bg-gold-500/10 p-4" data-id="element-248" data-mp="29uplcaiqsy9">
          <ZapIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-249" data-mp="b86glffarsr8" />
          <p className="text-[14px] font-semibold leading-snug text-white sm:text-base" data-id="element-250" data-mp="b6bzydb26msy">
            Es un sistema de consulta clínica diseñado para ayudarle a tomar decisiones más
            rápidas, más seguras y con mayor confianza — desde el primer diagnóstico hasta la
            monitorización a largo plazo.
          </p>
        </div>

        <SectionCta label="Quiero mi sistema de consulta clínica" tone="dark" data-id="element-251" data-mp="ux702o3enab7" />
      </div>
    </section>;
}